// If you add more categories to RealRelistingOption, this will throw an error because
// you need to add them here too. This could be avoided if we use enums
const relistingCategoryMap = {
    "cut-flower": "cut-flower",
    bouquet: "bouquet",
    bucket: "bucket",
    csa: "csa",
    "dried-flower": "dried-flower",
    "potted-plant": "potted-plant",
    wreath: "wreath",
};
/**
 * @deprecated
 */
export function narrowMaybeRelistingCategory(category) {
    // It might not be this, but that's what we are checking
    const relistingCategory = relistingCategoryMap[category];
    if (relistingCategory) {
        return { isRelistingCategory: true, category: relistingCategory };
    }
    else {
        return { isRelistingCategory: false, category };
    }
}
export function isRelistingCategory(category) {
    return relistingCategoryMap[category] !== undefined;
}
export function isRelisting(listing) {
    return !!listing.backingListing;
}
export function getOriginalSellerId(listing) {
    return getOriginalSeller(listing).profileId;
}
export function getOriginalSeller(listing) {
    return isRelisting(listing) ? listing.backingListing.seller : listing.seller;
}
/**
 * @deprecated use isRelisting
 */
export function narrowMaybeRelisting(listing) {
    if (listing.backingListing) {
        return { isRelisting: true, listing: listing };
    }
    else {
        return { isRelisting: false, listing };
    }
}
//# sourceMappingURL=listings.js.map